var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProjectTable',{attrs:{"projectList":_vm.projectList,"pageLoader":_vm.pageLoader,"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }